module.exports = __webpack_public_path__ + "img/poodle.5f4b6f0.png";